import { render, staticRenderFns } from "./OferteProductieGeneral.vue?vue&type=template&id=c3c1365e&scoped=true"
import script from "./OferteProductieGeneral.vue?vue&type=script&lang=js"
export * from "./OferteProductieGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c1365e",
  null
  
)

export default component.exports